module.exports = __webpack_public_path__ + "9bc2c2367148af7475f05167c835e67a.pdf";